import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=1cf50a6b&scoped=true"
import script from "./categoryForm.vue?vue&type=script&lang=js"
export * from "./categoryForm.vue?vue&type=script&lang=js"
import style0 from "./categoryForm.vue?vue&type=style&index=0&id=1cf50a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf50a6b",
  null
  
)

export default component.exports